import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { Dispatch, SetStateAction } from 'react';
import vconst from 'utils/helpers/structs/vconst';
import EToolTip from 'components/others/EToolTip';
import { isSameIdSet } from 'utils/helpers/list/isSameIdSet';
import SolarIcon from 'components/icons/SolarIcon';

const defaultServiceFilterStatus = [vconst.prodActive];

interface ServiceFilterStatusProps {
    filterStatus: number[];
    setFilterStatus: Dispatch<SetStateAction<number[]>>;
}

const ServiceFilterStatus = ({ filterStatus, setFilterStatus }: ServiceFilterStatusProps) => {
    const { t } = useTranslation(['Services']);
    const filterActive = !isSameIdSet(filterStatus, defaultServiceFilterStatus);

    return (
        <EToolTip title={t('toolArchiveFilter')}>
            <span className="d-inline-block">
                <Dropdown>
                    <Dropdown.Toggle
                        className="fs-14 px-2 ms-1"
                        size="sm"
                        variant={filterActive ? 'danger' : 'primary'}
                        id="dropdown-services-filter"
                    >
                        <SolarIcon name="funnel" className="fs-14 p-0" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item
                            onClick={(e) => {
                                e.currentTarget.blur();
                                setFilterStatus([vconst.prodActive, vconst.prodArchive]);
                            }}
                        >
                            <div className="me-2">
                                <input
                                    type="radio"
                                    checked={
                                        filterStatus?.includes(vconst.prodActive) &&
                                        filterStatus?.includes(vconst.prodArchive)
                                    }
                                    onChange={() => null}
                                    className="form-check-input"
                                />
                            </div>
                            {t('servArchive.all')}
                        </Dropdown.Item>

                        <Dropdown.Item
                            onClick={(e) => {
                                e.currentTarget.blur();
                                setFilterStatus([1]);
                            }}
                        >
                            <div className="me-2">
                                <input
                                    type="radio"
                                    checked={
                                        filterStatus?.includes(vconst.prodActive) &&
                                        !filterStatus?.includes(vconst.prodArchive)
                                    }
                                    onChange={() => null}
                                    className="form-check-input"
                                />
                            </div>
                            {t('servArchive.active')}
                        </Dropdown.Item>

                        <Dropdown.Item
                            className="text-danger"
                            onClick={(e) => {
                                e.currentTarget.blur();
                                setFilterStatus([0]);
                            }}
                        >
                            <div className="me-2">
                                <input
                                    type="radio"
                                    checked={
                                        !filterStatus?.includes(vconst.prodActive) &&
                                        filterStatus?.includes(vconst.prodArchive)
                                    }
                                    onChange={() => null}
                                    className="form-check-input"
                                />
                            </div>
                            {t('servArchive.archive')}
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </span>
        </EToolTip>
    );
};

export default ServiceFilterStatus;
